import { inject, NewInstance } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { SnapshotTypeService } from 'pages/system-fields/snapshot-types/service';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';

@inject(DialogController, NewInstance.of(ValidationController), DialogService, SnapshotTypeService)
export class SnapshotEdit {
    constructor(controller, validationController, dialogService, snapshotTypeService) {
        this.controller = controller;
        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('productionType').required()
            .ensure('snapshotTypeId').required()
            .rules;
        this.dialogService = dialogService;
        this.snapshotTypeService = snapshotTypeService;
        this.groupMode = 'existing';
        this.snapshot = {};
    }

    activate(model) {
        this.quoteId = model.quoteId;
        this.snapshot = model.snapshot;
    }

    setGroupMode(mode) {
        this.groupMode = mode;
        if (this.groupMode == 'existing') {
            this.snapshot.name = null;
            this.snapshot.description = null;
        } else {
            this.snapshot.groupId = null;
        }
    }

    addSnapshotType() {
        this.dialogService.open({ viewModel: this.snapshotTypeService.editor });
    }

    async save() {
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            this.snapshot.quoteId = this.quoteId;
            this.controller.ok(this.snapshot);
        }
    }
}
